module.exports = __webpack_public_path__ + "static/img/icon_orders.c1ebe320.png";